// extracted by mini-css-extract-plugin
export default {"titleText":"style_titleText__yRa20","itemText":"style_itemText__CRDVw","qwe":"style_qwe__BkIYv"};